import React, { FC } from 'react';
import {
  Box,
  Typography,
  Grid,
  Container,
  Button,
  List,
  ListItem,
} from '@mui/material';
import StyledBox, { StyledCarousel } from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OurFleetSection/OurFleetSection.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import {
  ImgBox,
  Typography700,
} from 'views/rebranded-module/common/components';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { RiCheckFill } from 'react-icons/ri';
import Typography500 from 'views/common/components/UI/Typography500';
import PATHS from 'lib/navigation/paths';
import { OFF_ROAD_LANDING_REF } from 'views/rebranded-module/OffRoadToursLandingViewV2/utils/constants';

interface VehicleMake {
  name: string;
}

interface Model {
  id: number | string;
  name: string;
  image?: {
    medium_url?: string;
  };
  vehicle_make: VehicleMake;
}

interface OurFleetSectionProps {
  models: Model[];
}

const OurFleetSection:FC<OurFleetSectionProps> = (props) => {
  const { models } = props;
  const content = useContent('OffRoadLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();
  const tourLink = PATHS.tour.index(
    content.adventureTourType,
    content.adventureSlug,
    {
      ref: OFF_ROAD_LANDING_REF,
    },
  );
  return (
    <StyledBox>
      <Box className="OFSBGPattern">
        <ImgBox
          image={{
            src: getSizedImage(content.patternBackground),
            alt: content.patternBackground.alt,
          }}
          width="100%"
          height="100%"
          unoptimized
        />
      </Box>
      <Box className="OFSContent">
      <Container maxWidth="xl">
        <Box className="OFSTitleContainer">
          <Box>
            <Typography700 variant="h3" component="h2" mb={2}>
              {content.fleetTitle}
            </Typography700>
            <Typography500 component="p" variant="body1" color="text.secondary">
              {content.fleetDescription}
            </Typography500>
          </Box>
          <Button
            className="ORBFullWidth"
            variant="contained"
            component={NavigatorLink}
            href={tourLink}
            >
            {content.fleetBtn}
          </Button>
        </Box>

        <Grid container spacing={8}>
          <Grid item lg={6} md={12} sm={12}>
            <List disablePadding>
              {content.fleetList.map((fleet) => (
                <ListItem
                  className="OFSListItem"
                  key={fleet.benefitText}
                  disableGutters>
                  <RiCheckFill className="OFSIcon" />
                  <Typography500
                    component="p"
                    variant="body1"
                    color="text.secondary"
                    dangerouslySetInnerHTML={{
                      __html: fleet.benefitText,
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Grid>
          <Grid item xl={6} lg={6} md={12} sm={12} className="OFSSlider">
            <StyledCarousel
              showDots={false}
              desktopPartialVisibilityGutter={models.length > 2?  30 : 0 }
              largeDesktopPartialVisibilityGutter={models.length > 2?  75 : 0 }
              deskTopItems={2}
              tabletItem={3}
              carouselArrow
              tabletPartialVisibilityGutter={0}
              mobilePartialVisibilityGutter={70}
              customTransition="transform 200ms ease-in">
              {models.map((item) => (
                <Box className="CarouselItem" key={item.id}>
                  <Box className="OFSBikeCard">
                    <Box className="OFSImgContainer">
                      <ImgBox
                        image={{
                          src: item.image?.medium_url,
                          alt: item.name,
                        }}
                        imgHeight="100%"
                        imgWidth="100%"
                        imgObjectFit="contain"
                      />
                    </Box>
                    <Box className="MMSTextContainer">
                      <Typography700 component="p" variant="h7" my={1.25}>
                        {item.vehicle_make.name}
                      </Typography700>
                      <Typography component="p" variant="body2"  color="text.secondary">
                        {item.name}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ))}
            </StyledCarousel>
          </Grid>
        </Grid>
      </Container>
      </Box>
    </StyledBox>
  );
};

export { OurFleetSection };
